import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

import FullPageMode from './pages/FullPageMode.vue';

// Router Plugin is used in VideoTools and Arena Vue Instance
// Regisering it twice causes an error, so we only register it on specific pages
if (window.location.pathname.startsWith('/event')) {
	Vue.use(Router);
}

const router = new Router({
	mode:   'history',
	routes: [
		{
			path:      '/event/:id/:slug',
			name:      'FullPageModeEvent',
			component: FullPageMode,
			beforeEnter(_to, from, next) {
				// Only reset if navigating from another route (not on initial load)
				if (from.name) {
					store.dispatch('app/reset');
				}
				next();
			},
		},
		{
			path:      '/event/:id/tag/:eventTag',
			name:      'FullPageModeEventTag',
			component: FullPageMode,
			beforeEnter(_to, from, next) {
				// Only reset if navigating from another route (not on initial load)
				if (from.name) {
					store.dispatch('app/reset');
				}
				next();
			},
		},
		{
			path:      '/event/:id/tag/:eventTag/debug',
			name:      'FullPageModeEventTagDebug',
			component: FullPageMode,
			beforeEnter(_to, from, next) {
				// Only reset if navigating from another route (not on initial load)
				if (from.name) {
					store.dispatch('app/reset');
				}
				next();
			},
		},
	],
});

export default router;
